import { get } from 'lodash';
import {
	CANCEL_MANDATE_FAILURE,
	CANCEL_MANDATE_SUCCESS,
	CANCEL_MANDATE_API_CALL,
	SHOW_CANCEL_MANDATE_VIEW,
	HIDE_CANCEL_MANDATE_VIEW,
} from './actions';

export const cancelModalView = 'cancelModalView';
export const cancelModalSuccess = 'cancelModalSuccess';
export const cancelModalFailure = 'cancelModalFailure';

export const initialState = {
	isCancelApiInProgress: false,
	showCancelModal: false,
	cancelModalName: cancelModalView,
};

const manageCancel = (state = initialState, action) => {
	if (
		(action.type === CANCEL_MANDATE_API_CALL && get(action, 'error', false)) ||
		action.type === CANCEL_MANDATE_FAILURE
	) {
		return {
			...state,
			isCancelApiInProgress: false,
			cancelModalName: cancelModalFailure,
			cancelApiError: get(action, 'payload.response.error', {}),
		};
	}

	switch (action.type) {
		case CANCEL_MANDATE_API_CALL:
			return {
				...state,
				isCancelApiInProgress: true,
			};
		case SHOW_CANCEL_MANDATE_VIEW:
			return {
				...state,
				showCancelModal: true,
				cancelModalName: cancelModalView,
				mandateToCancel: action.mandate,
			};
		case HIDE_CANCEL_MANDATE_VIEW:
			return {
				...state,
				...initialState,
			};
		case CANCEL_MANDATE_SUCCESS:
			return {
				...state,
				cancelModalName: cancelModalSuccess,
				isCancelApiInProgress: false,
			};
		default:
			return state;
	}
};

export default manageCancel;
